module.exports = __webpack_public_path__ + "img/noti6.ef043db2.jpg";